export const getUsuarioFromSession = (sessionResponse) => (
  sessionResponse?.nombreUsuario || sessionResponse?.usuario
    ? sessionResponse
    : (
      sessionResponse?.data?.user
      ?? sessionResponse?.data?.usuario
      ?? sessionResponse?.data
      ?? sessionResponse?.user
      ?? sessionResponse?.usuario
      ?? sessionResponse
    )
)

export const getPermisosUsuario = (usuario) => usuario?.permisos || {}

export const puedeEditarPlanificacion = (usuario) => Boolean(getPermisosUsuario(usuario).puedeEditarPlanificacion)

export const puedeGestionarUsuarios = (usuario) => Boolean(getPermisosUsuario(usuario).puedeCrearUsuarios)

export const puedeEditarMaestrosGlobales = (usuario) => Boolean(getPermisosUsuario(usuario).puedeEditarMaestrosGlobales)

export const puedeEditarMaestrosAlmacen = (usuario) => Boolean(getPermisosUsuario(usuario).puedeEditarMaestrosAlmacen)

export const puedeSincronizarBusinessCentral = (usuario) => Boolean(getPermisosUsuario(usuario).puedeSincronizarBusinessCentral)

export const puedeVerAjustes = (usuario) => (
  puedeGestionarUsuarios(usuario)
  || puedeEditarMaestrosGlobales(usuario)
  || puedeEditarMaestrosAlmacen(usuario)
  || puedeSincronizarBusinessCentral(usuario)
)

export const puedeVerOpcionAjustes = (usuario, permiso) => {
  if (permiso === 'usuarios') return puedeGestionarUsuarios(usuario)
  if (permiso === 'roles') return puedeGestionarUsuarios(usuario)
  if (permiso === 'maestrosBusinessCentral') return puedeEditarMaestrosGlobales(usuario) || puedeSincronizarBusinessCentral(usuario)
  if (permiso === 'maestrosGlobales') return puedeEditarMaestrosGlobales(usuario)
  if (permiso === 'maestrosAlmacen') return puedeEditarMaestrosAlmacen(usuario)

  return false
}
